import React, { useState, useEffect } from "react";
import "../assets/css/team.scss";
import LeftSideEditProfile from "./../LeftSideEditProfile";
import { Title } from "./../videoPhoto/Component";
import eventLogoImg02 from "./../assets/img/event-logo-img02.png";
import VerificationIcon from "./../assets/img/complete-verification-icon.svg";
import MuiAutoComplete from "../../../../../common/AutoComplete";
import {
  fetchGraphMethod,
  fetchMethod,
} from "../../../../../../services/httpService";
import coacheImg1 from "./../assets/img/coache-img1.png";
import eventLogoImg01 from "./../assets/img/event_default.png";
import {
  getAllAddedEventsQuery,
  getFilteredAddEventDataQuery,
  saveAddedEventQuery,
} from "./AddEditEventFormQuery";
import {connect, useDispatch, useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import { getUserInfo } from "../../../../../../services/authService";
import { addAddedEventFormsaveStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/addAddedEvent";
import messagePopup from "../../../../../../utils/messagePopup";
import {imageDownloadUrl} from "../../../../../../config";
import {getAllOrganizationsQuery, getFilAllOrganizationsQuery} from "../../../../../common/CommonQuery";
import {getUTCTimeDateDash, getUTCTimeDateOverall} from "../../../../../../utils/dateTimeFormatter";
import BackdropLoader from "../../../../../common/Loader";
import moment from 'moment'

const SubHeader = ({ onSideMenuClick }) => {
  return (
    <div className="subHeader">
      <div className="menu">
        <button onClick={onSideMenuClick}>
          <span></span> Edit Profile
        </button>
      </div>
      {JSON.parse(localStorage.getItem('user')).verifiedUserStatus === 1 ?
        <div className="profile-verified-text">
          <span className="verifiedIcon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26.418"
              height="26.403"
              viewBox="0 0 26.418 26.403"
            >
              <defs>
                <style></style>
              </defs>
              <path
                className="a"
                d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                transform="translate(4244.209 6690.181)"
              />
            </svg>
          </span>
          Congrats your profile is verified
        </div>
        : <div className="profile-verified-text">
          <img
            className="icon"
            src={VerificationIcon}
            alt="Verified"
          />
          Your profile is not verified for college coaches.
          <a style={{"cursor":"pointer"}} onClick={()=>window.open('https://calendly.com/sportsforce/recruiting-assessment-round-robin','_blank')}>Complete Verification Now</a>
        </div>}
      <div className="save">
        {/* <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.889"
            height="13.945"
            viewBox="0 0 13.889 13.945"
          >
            <g id="save" transform="translate(0 -0.001)">
              <path
                id="Path_2125"
                data-name="Path 2125"
                d="M13.38,2.1,11.793.508A1.736,1.736,0,0,0,10.565,0H9.548V3.038a.434.434,0,0,1-.434.434H2.17a.434.434,0,0,1-.434-.434V0H.868A.868.868,0,0,0,0,.868V13.021a.868.868,0,0,0,.868.868H13.021a.868.868,0,0,0,.868-.868v-9.7A1.736,1.736,0,0,0,13.38,2.1ZM12.153,12.153H1.736V6.944H12.153Z"
                transform="translate(0 0.058)"
                fill="#3e3e3e"
              />
              <rect
                id="Rectangle_416"
                data-name="Rectangle 416"
                width="2"
                height="3"
                transform="translate(5.457 0.001)"
                fill="#3e3e3e"
              />
            </g>
          </svg>
          Save
        </button> */}
      </div>
    </div>
  );
};

const Event = ({ props, id, eventname, city, eventstateidrel, eventLogo,createdby, user }) => {
  let history = useHistory();
  const handleAddEvent = async (e, data) => {
    props.addAddedEventSingleData(data);
    let eventId = data ? data : "";

    const variables = {
      where: {
        addedby: getUserInfo() ? getUserInfo().id : 0,
        eventid: eventId,
      }
    }
    let response = await fetchGraphMethod(getAllAddedEventsQuery, variables, true)
    if (response.data.data.allEventmappings.totalCount === 0) {
      props.data.addAddedEventFormsaveStart({
        query: saveAddedEventQuery,
        variables: {
          obj: {
            addedby: getUserInfo() ? getUserInfo().id : 0,
            eventid: eventId,
          },
        },
      });
      messagePopup("", "Event Added Successfully", "success")
      //below code is for check when user come from checklist
      if(props?.data?.location?.previousPage) return history.push(`/${props?.data?.location?.previousPage}`);
      history.push("/events");
    } else {
      handleAlreadyAddedEvent()
    }
  };
   const getUTCTimeDateDashEvent = (value) =>{
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let day = !!value ? value?.split("-")?.[2] : "1",
        dbMonth = !!value ? value?.split("-")?.[1] : "1",
        month = months[parseInt(dbMonth - 1)]
     if (day?.length?.toString() > 1){
       if (day?.split("")?.[0] == "0"){
         const newDate =  day?.split("")?.[1]
           day = newDate
       }
     }
    return `${month} ${day}`
  }
  const handleAlreadyAddedEvent = (createdby) => {
    messagePopup("", "Event already added to your profile.", "warning");
  };
  return (
    <>
      <li className="team-flex-item">
        <div className="item-content-box">
          <div className="icon-box">
            <img src={!!eventLogo ? `${imageDownloadUrl}/${eventLogo}` : eventLogoImg01} alt="" />
          </div>
          <div className="content-box">
            <h4>{eventname}
            <span style={!!user?.eventorgname ? {marginLeft:"5px"} : {}}>{!!user?.eventorgname ? ` @${user?.eventorgname}` : ""}</span>
            </h4>
            <p>
              {city}
              {!!user?.stateinitial && !!city ? ", " : ""}
              {!!user?.stateinitial ? user?.stateinitial : ""}
            </p>
            <p>{!!user?.startdate ? getUTCTimeDateDashEvent(user?.startdate) ?? "" : ""} {!!user?.enddate ? ` - ${getUTCTimeDateDashEvent(user?.enddate) ?? ""}` : ""}</p>
          </div>
        </div>
        <div className="item resend-request-button">
          <a onClick={(e) => handleAddEvent(e, id)}
            className="btn green">
            Add Event
          </a>
        </div>
      </li>
    </>
  );
};

const EditSection = (props) => {
  let history = useHistory()
  const [fields, setFields] = useState({
    searchEventname: "",
    searchCityState: "",
    eventName: "",
    city:"",
    state:"",
    eventOrganisation: ""
  });
  const [filEvent, setFilEvent] = useState({
    eventname:"",
    organizationname:"",
    startdate:"",
    enddate:"",
    city:"",
    month:"",
    year:"",
    stateid:0,
    // limit:100,
    // offset:0
  })

  const [eventsArray, setEventsArray] = useState([]);
  const [allState, setAllState] = useState([])
  const [allOrg, setAllOrg] = useState([])
  const [allYear, setAllYear] = useState([])
  const [allMonths, setAllMonths] = useState([])
  const [allEvent, setAllEvent] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [selEventOrg, setSelEventOrg] = useState({})
  const [selEventNameOrg, setSelEventNameOrg] = useState({})
  useEffect(()=>{
    getAllState()
    // getAllOrganization()
    // getAllEvent()
    getAllYear()
    getAllMonth()
    getFirstData()
  },[])
  const getFirstData = () =>{
    const cloneState = filEvent
    cloneState["startdate"] = ""
        // moment(new Date()).format('YYYY-MM-DD')
    cloneState['enddate'] = ""
        // moment(cloneState['startdate']).add(90,'days').format('YYYY-MM-DD')
    cloneState['month'] = "14"
    getFilFilEventSearch(cloneState)
  }
  const getAllState = async () =>{
    const _res = await fetchMethod('/allState', '','GET')
    if (_res?.status == 200){
        const allData = _res?.data?.data?.length > 0 ? _res?.data?.data : []
      if (allData?.length > 0){
        allData?.sort((a,b)=>{
          if (a?.statename < b?.statename) return -1
          return 1
        })
      }
      setAllState(allData)
    }else {
      setAllState([])
    }
  }
  const getAllOrganization = async () =>{
    const _res = await fetchGraphMethod(getAllOrganizationsQuery,null,true)
    if (_res?.status == 200){
      const allOrg = _res?.data?.data?.allOrganizations?.Organizations?.length > 0 ? _res?.data?.data?.allOrganizations?.Organizations : []
      setAllOrg(allOrg)
    }else{
      setAllOrg([])
    }
  }
  const getAllYear = async () =>{
    const _res = await fetchMethod('/allGraduationYears', null, 'GET')
    if (_res?.status == 200){
        const allYear = _res?.data?.data?.length > 0 ? _res?.data?.data : []
      setAllYear(allYear)
    }else {
      setAllYear([])
    }
  }
  const getAllMonth = async () =>{
    const _res = await fetchMethod('/allGraduatioMonth', null, 'GET')
    if (_res?.status == 200){
      const allMonth = _res?.data?.data?.length > 0 ? _res?.data?.data : []
      allMonth.unshift({id: allMonth?.length + 1, monthvalue: "Next 3 months"})
      allMonth.unshift({id: allMonth?.length + 1, monthvalue: "Select Month"})
      setAllMonths(allMonth)
    }else{
      setAllMonths([])
    }
  }
  const getAllEvent = async () =>{
    const _res = await fetchGraphMethod(getFilteredAddEventDataQuery, {where:{isverified: 1, active:1}}, true)
    if (_res?.status == 200){
      const allEvnt = _res?.data?.data?.allEvents?.Events?.length > 0 ? _res?.data?.data?.allEvents?.Events  : []
      setAllEvent(allEvnt)
    }else{
      setAllEvent([])
    }
  }
  const getUTCDateYMD = (value) =>{
    let date = (new Date(`${value}`)),
        day = date?.getUTCDate(),
        month = date?.getUTCMonth()+1,
        year = date?.getUTCFullYear();
    return `${year}-${month?.toString()?.length > 1 ? `${month}` : `0${month}`}-${day}`
  }
  const handleForAll = (e, field) =>{
    const value = !!e?.target?.value ? e?.target?.value : ""
    const cloneState = filEvent
    if (field == "city" && !!value){
      if (value?.length < 3) return
      cloneState[field] = value
      getFilFilEventSearch(cloneState)
    }
    else if (field == "stateid"){
      cloneState[field] = parseInt(value)
      getFilFilEventSearch(cloneState)
    }
    else if(field == "month"){
      if (parseInt(value) == 13){
        cloneState["startdate"] = moment(new Date()).format('YYYY-MM-DD')
        cloneState['enddate'] = moment(cloneState['startdate']).add(90,'days').format('YYYY-MM-DD')
        cloneState['month'] = value
        cloneState['year'] = "";
      }else{
        cloneState[field] = !!value ? value : ""
        cloneState['startdate'] = ""
        cloneState['enddate'] = ""
        // if (!cloneState['year']){
        //   cloneState['year'] = new Date().getFullYear()?.toString() ?? "2023"
        // }
      }
      getFilFilEventSearch(cloneState)
    }
    else if (field == "year"){
        cloneState['startdate'] = ""
        cloneState['enddate'] = ""
        cloneState['month'] = "14"
        cloneState[field] = value
        getFilFilEventSearch(cloneState)
    }
    else {
      cloneState[field] = value
      getFilFilEventSearch(cloneState)
    }
  }
  const handleForEventOrg = async (e, field) =>{
    const value = !!e?.target?.value ? e?.target?.value : ""
    let cloneField = filEvent
    if (!!value && value?.length > 2){
      const orgInput = {where: {active: 1,isverified: 1,...(setSelEventNameOrg && {id : selEventNameOrg?.eventorgid}), and: [{or: [{eventorgname: {like: `%${value}%`, options: "i",},},],},],},}
      const _res = await fetchGraphMethod(getFilAllOrganizationsQuery, orgInput, true)
      if (_res?.status == 200){
        const allOrgData = _res?.data?.data?.allOrganizations?.Organizations?.length > 0 ? _res?.data?.data?.allOrganizations?.Organizations : []
        setAllOrg(allOrgData)
        // cloneField[field] = value
        // getFilFilEventSearch(cloneField)
      }else{
        // cloneField[field] = ""
        // getFilFilEventSearch(cloneField)
        setAllOrg([])
      }
    }else{
      // cloneField[field] = ""
      // getFilFilEventSearch(cloneField)
      setAllOrg([])
    }
  }
  const handleForEventName = async (e, field) =>{
    const value = !!e?.target?.value ? e?.target?.value : ""
    let cloneField = filEvent
    if (!!value && value?.length > 2){
      const orgInput = {where:{active: 1,isverified: 1,...(selEventOrg && {eventorgid : selEventOrg?.id}), and: [{or: [{eventname: {like: `%${value}%`, options: "i",},},],},],}}
      const _res = await fetchGraphMethod(getFilteredAddEventDataQuery, orgInput, true)
      if (_res?.status == 200){
        const allEvntData = _res?.data?.data?.allEvents?.Events?.length > 0 ? _res?.data?.data?.allEvents?.Events : []
        setAllEvent(allEvntData)
        cloneField[field] = value
        getFilFilEventSearch(cloneField)
      }else{
        cloneField[field] = ""
        getFilFilEventSearch(cloneField)
        setAllEvent([])
      }
    }else{
      cloneField[field] = ""
      getFilFilEventSearch(cloneField)
      setAllEvent([])
    }
  }
  const onSelectEventOrg = (e, field) =>{
    const value = !!e?.target?.value ? e?.target?.value?.eventorgname : e?.target?.value
    let cloneState = filEvent
    if (!!value){
      cloneState[field] = value
      getFilFilEventSearch(cloneState)
      setSelEventOrg(e?.target?.value)
        setAllEvent([])
    }else {
      setSelEventOrg({})
      cloneState[field] = ""
      getFilFilEventSearch(cloneState)
    }
  }
  const onSelectEventName = (e, field) =>{
    const value = !!e?.target?.value ? e?.target?.value?.eventname : e?.target?.value
    let cloneState = filEvent
    if (!!value){
      cloneState[field] = value
      getFilFilEventSearch(cloneState)
      setSelEventNameOrg(e?.target?.value)
        setAllOrg([])
    }else {
      setSelEventNameOrg({})
      cloneState[field] = ""
      getFilFilEventSearch(cloneState)
    }
  }
  const getFilFilEventSearch = async (dataObj) =>{
    setIsLoading(true)
    const _res = await fetchMethod('/api/Events/searchEvent',dataObj,'POST', true)
    if (_res?.status == 200){
      setFilEvent(dataObj)
      const eventfilData = _res?.data?.response?.data?.length > 0 ? _res?.data?.response?.data : []
      if (!!dataObj?.eventname|| !!dataObj?.organizationname || dataObj?.startdate || !!dataObj?.enddate ||
          !!dataObj?.city || !!dataObj?.stateid || !!dataObj?.year || !!dataObj?.month){
        setEventsArray(eventfilData)
        setIsLoading(false)
      }else{
        setEventsArray([])
        setIsLoading(false)
      }
    }else{
      setEventsArray([])
      setIsLoading(false)
    }
  }
  return (
     <>
       <BackdropLoader open={isLoading}/>
    <div className="editSection">
      <Title title={"Events"} />
      <div className="check-list-sec">
        <div className="editprofile-common-form team-common-form">
          <form>
            <h3>Add / Edit Upcoming Event</h3>
            <div className="fieldBox flexBox">
              <div className="half">
                <label>Event Organization</label>
                <MuiAutoComplete
                    id="eventOrg"
                    freeSolo={true}
                    options={allOrg}
                    getOptionLabel={(option) =>
                        option.eventorgname ? option.eventorgname : ""
                    }
                    value={fields.eventOrganisation || ""}
                    onChange={(event, newValue) => {
                      handleForEventOrg(
                          { target: { value: newValue } },
                          "organizationname"
                      );
                    }}
                    onChangeObj={(e, newValue) => {
                      onSelectEventOrg(
                          { target: { value: newValue } },
                          "organizationname"
                      );
                    }}
                    inputPlaceholder="Enter event organization"
                />
              </div>
              <div className="half">
                <label>Event Name</label>
                <div className={'eventAuto-wrapper'}>
                  <MuiAutoComplete
                      id="eventName"
                      freeSolo={true}
                      options={allEvent}
                      getOptionLabel={(option) =>
                          option.eventname ? option.eventname : ""
                      }
                      value={fields.searchEventname}
                      onChange={(e, newValue) => {
                        handleForEventName(
                            { target: { value: newValue } },
                            "eventname"
                        );
                      }}
                      onChangeObj={(e, newValue) => {
                        onSelectEventName(
                            { target: { value: newValue } },
                            "eventname"
                        );
                      }}
                      inputPlaceholder="Enter event name"
                  />
                </div>
              </div>
            </div>
            <div className="fieldBox flexBox">
              <div className="half">
                <label>Year</label>
                <select
                value={filEvent?.year ?? ""}
                onChange={(e)=>handleForAll(e, 'year')}
                >
                  <option value="">Select Year</option>
                  {allYear?.length > 0 &&
                  allYear?.map(yr =><option value={yr?.yearValue}>{yr?.yearValue}</option>)
                  }
                </select>
              </div>
              <div className="half">
                <label>Month</label>
                <select
                    value={filEvent?.month ?? ""}
                    onChange={(e)=>handleForAll(e, 'month')}>
                  {/*<option value="">Select month</option>*/}
                  {allMonths?.map(mt => <option value={mt?.id}>{mt?.monthvalue}</option>)}
                </select>
              </div>
            </div>
            <div className="fieldBox flexBox">
              <div className="half">
                <label>City</label>
                <input
                  type="text"
                  onChange={(e) => {
                    handleForAll(e, 'city')
                  }}
                  placeholder="Enter City"
                />
              </div>
              <div className="half">
                <label>State</label>
                <select
                    value={filEvent?.stateid ?? ""}
                    onChange={(e)=>handleForAll(e, 'stateid')}
                >
                  <option value={0}>Select state</option>
                  {allState?.length > 0 &&
                  allState?.map(st =><option value={st?.id}>{st?.statename ?? ""}</option>)
                  }
                </select>
              </div>
            </div>
            <div className="fieldBox flexBox">
              <div className="half inner-mb0">
              </div>
            </div>

                  <div className="coches-request-wrap teams-seach events-search">
                    {eventsArray?.length > 0 && <h4 className="title">Total Events {eventsArray?.length}</h4>}
                    <ul className="coache-listing"
                        style={eventsArray?.length > 0 ? eventsArray?.length > 5 ? {display:"block"} : {display: "block", overflowY:"hidden", height:"auto"} :{display:"none"}}
                    >
                      { eventsArray?.length > 0 &&
                      eventsArray.map((users, idx) => (
                      <Event
                        eventLogo={users?.eventlogoname ?? ""}
                        key={idx}
                        {...users}
                        props={props}
                        user={users}
                        addAddedEventSingleData={props.addAddedEventSingleData}
                      />
                      ))}
                    </ul>
                  </div>
            <div className="form-button-box d-block border-0 pt-0 mb-0">
              <div className="text-box">
                <p>
                  I can't find my event
                  <br />
                  <a className="continue-link color-red"
                     href={void 0}
                     // href="#/events/event-form/0"
                      style={{cursor: "pointer"}}
                      onClick={(e)=>{
                        e.preventDefault()
                        history.push({
                          pathname:"/events/event-form/0",
                          previousPage: props?.data?.location?.previousPage || "",
                          state: {
                            eventName: filEvent?.eventname ?? "",
                            city: filEvent?.city ?? "",
                            state: filEvent?.stateid ?? "",
                            eventOrg: selEventOrg,
                          }
                        })
                      }}
                  >
                    Continue
                  </a>
                </p>
              </div>
              <Link className="btn orange" to="/events">
                Back
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
     </>
  );
};

const AddEvent = (props) => {
  const store = useSelector(store => store)
  const [sideMenuOpen, setSideMenu] = useState(store?.athlete?.editUserProfileData?.eventSideBarStatus?.status || false);
  // const [sideMenuOpen, setSideMenu] = useState(false);
  const [singleAddedEventValue, setSingleAddedEventValue] = useState([]);
  //this is used for dispatching redux action
  const dispatch = useDispatch()
  const onSideMenuClick = () => {
    setSideMenu(!sideMenuOpen);
    //func of redux
    dispatch({type:"EVENT_SIDE_BAR_START", payload: {status: !sideMenuOpen}})
  };

  const addAddedEventSingleData = (addedEventData) => {
    setSingleAddedEventValue(addedEventData == undefined ? [] : addedEventData);
  };
  //funcis used for scrolling the page on top
useEffect(()=>{
  setTimeout(()=>{
    window.scrollTo(0,0)
  },1800)
},[])
  return (
    <div className="pageContent">
      <div className="editProfile">
        <div className="container">
          <div
            id="wrapper"
            className={`flex ${sideMenuOpen ? "inactive" : ""}`}
          >
            <SubHeader onSideMenuClick={onSideMenuClick} />
            <div className="sidebar">
              <LeftSideEditProfile />
            </div>
            <EditSection
              data={props}
              addAddedEventSingleData={addAddedEventSingleData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    allAddEditEventForm: state.athlete.editUserProfileData.addEditEventFormList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addAddedEventFormsaveStart: (data) =>
      dispatch(addAddedEventFormsaveStart(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEvent);
